import { Capacitor } from "@capacitor/core";

// Keeps browser chrome (theme-color) and native iOS/Android status bar in sync with the ADE theme
export const syncNativeChrome = async (isDark) => {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", isDark ? "#0a0a0a" : "#ffffff");
  document.documentElement.style.backgroundColor = isDark ? "#0a0a0a" : "#ffffff";
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // Style.Dark = dark background -> LIGHT icons; Style.Light = light background -> DARK icons
    await StatusBar.setStyle({ style: isDark ? Style.Dark : Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: isDark ? "#0a0a0a" : "#ffffff" });
    }
  } catch (e) {
    // StatusBar plugin unavailable (web) — ignore
  }
};
